import { queryDpMessage } from '@tencent/wphk-components-dp-loader';
import { handleHomeBanner } from '@/business/home';

/**
 * 获取顶部banner列表数据
 */
export async function getTopBannerList() {
  const dpMessageRes = await queryDpMessage({
    dpPage: '110004000046',
    dpPositions: ['1100040000460001'],
  });
  return handleHomeBanner(dpMessageRes?.dpList);
}
